"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseDataFromProductAttributions = exports.mergeTextAndMeasureProductAttributions = void 0;
const product_details_dialog_constants_1 = require("./product-details-dialog.constants");
const product_1 = require("../../client/product");
const utils_1 = require("../../utils");
const mergeTextAndMeasureProductAttributions = (textAttributions, measureAttributions) => {
    var _a, _b;
    const productTextAttributions = (_a = textAttributions === null || textAttributions === void 0 ? void 0 : textAttributions.edges.reduce((acc, { node: { label, value, origin, assertedIncorrect, status, }, }) => (assertedIncorrect ? acc : [...acc, {
            label, value, origin, isValid: product_1.VALID_STATUSES.includes(status),
        }]), [])) !== null && _a !== void 0 ? _a : [];
    const productMeasureAttributions = (_b = measureAttributions === null || measureAttributions === void 0 ? void 0 : measureAttributions.edges.map(({ node: { dimension, value, unit, origin, status, }, }) => ({
        label: dimension,
        value,
        unit,
        origin,
        isValid: product_1.VALID_STATUSES.includes(status),
    }))) !== null && _b !== void 0 ? _b : [];
    const mergedProductAttributions = [...productTextAttributions, ...productMeasureAttributions];
    return (0, utils_1.sortByTextFieldCaseInsensitive)(utils_1.SortOrder.Ascend)(mergedProductAttributions, 'label');
};
exports.mergeTextAndMeasureProductAttributions = mergeTextAndMeasureProductAttributions;
const getBaseDataFromProductAttributions = (product, productAttributions) => {
    var _a;
    if (!product || !productAttributions.length) {
        return {};
    }
    const { name, createdAt, categories, externalId, } = product;
    const baseProductData = {
        createdAt,
        name,
        externalId,
        classificationProductType: (_a = categories === null || categories === void 0 ? void 0 : categories.edges[0]) === null || _a === void 0 ? void 0 : _a.node.category,
    };
    product_details_dialog_constants_1.BASE_ATTRIBUTE_NAMES.forEach((baseAttributeName) => {
        var _a;
        const { value } = (_a = productAttributions.find(({ label }) => label === baseAttributeName)) !== null && _a !== void 0 ? _a : {};
        baseProductData[baseAttributeName] = String(value !== null && value !== void 0 ? value : '-');
    });
    return baseProductData;
};
exports.getBaseDataFromProductAttributions = getBaseDataFromProductAttributions;
